import { Canvas, useLoader } from "@react-three/fiber";
import { TextureLoader, ACESFilmicToneMapping } from "three";
import { OrbitControls, Float, Stars } from "@react-three/drei";
import OrbitsComponant from "./orbitsComponant";

function InteractiveGlobeComponent() {
  const [ mapWithLogo] = useLoader(TextureLoader, [
    "./material/satr-globe-with-logo.png",
  ]);

  return (
    <div className="flex justify-center items-center h-full w-full bg-transparent mx-auto">
      <Canvas
        gl={{ antialias: true, toneMapping: ACESFilmicToneMapping }}
        camera={{
          fov: 75,
          zoom: 1.5,
          near: 0.1,
          far: 200,
          position: [10, 20, 20],
        }}
      >
        <OrbitControls
          maxDistance={50}
          minDistance={20}
          minPolarAngle={Math.PI / 6}
          maxPolarAngle={Math.PI - Math.PI / 2}
        />
        {/* Satr Sphere */}
        <Float
          speed={1}
          rotationIntensity={1}
          floatIntensity={1}
          floatingRange={[-0.5, 0.5]}
        >
          <group>
            <mesh
              onPointerEnter={(e) => {
                document.body.style.cursor = "pointer";
                e.stopPropagation();
              }}
              onPointerLeave={() => {
                document.body.style.cursor = "default";
              }}
              onClick={(e) => {window.open("https://satr.codes/", "_blank");
            e.stopPropagation();}}
              visible
              position={[0, 0, 0]}
            >
              <sphereGeometry args={[2.9, 128, 128]} />
              <meshMatcapMaterial matcap={mapWithLogo} />
            </mesh>
          </group>
        </Float>
        <OrbitsComponant />
        <Stars
          radius={0.1}
          depth={-30}
          count={400}
          factor={1.5}
          saturation={9}
          fade
          speed={2}
        />
      </Canvas>
    </div>
  );
}

export default InteractiveGlobeComponent;
